import React from 'react';
import { useUpdatePhotoCaption } from '../hooks/useUpdatePhotoCaption';
import { IPortalPropertyPhotoObj, IUpdateTitlePayLoad } from '../../../../interfaces/asset';
import { showErrorDialog } from '../helpers';
import { Button } from '../../../common/button';
import { Modal } from '../../../common/modal';
import { Form } from '../../../common/form';
import { FormInput } from '../../../common/form_input';

interface IProps {
    nhID: number;
    photoDetail: IPortalPropertyPhotoObj;
    handleClose(): void;
}

const PhotoCaptionUpdateModal = ({
    photoDetail, 
    handleClose, 
    nhID   
}: IProps) => {
    const { mutate, isPending } = useUpdatePhotoCaption();
    
    const defaultFormValues = {
        PhotoCaption: photoDetail?.Title || ''
    };

    const onSubmit = async (data: any) => {
        const { PhotoCaption } = data;

        const payload: IUpdateTitlePayLoad = {
            NHID: nhID,
            AssetID: photoDetail.AssetID,
            Title: PhotoCaption || ''
        };

        mutate(payload, { 
            onError: () => showErrorDialog('Failed to update the caption for the photo.') 
        });
        handleClose();
    };

    const actionButtons = (
        <Button 
            type="submit"
            form="photo_caption_modal"
            isLoading={isPending}
        >
            Update Caption
        </Button>        
    );

    return (
        <Modal
            isOpen={true}
            onClose={handleClose}
            title={<>Update Photo Caption For Photo ID: {photoDetail.AssetID}</>}
            footerContent={actionButtons}
            size='md'
            blurBackdrop
        >
            <Form onSubmit={onSubmit} id="photo_caption_modal" defaultValues={defaultFormValues}>
                <FormInput label='Photo Caption' name='PhotoCaption' />
            </Form>
        </Modal>
    );
};

export default PhotoCaptionUpdateModal;
